import { render, staticRenderFns } from "./MonthlyPaymentCard.vue?vue&type=template&id=3885e5da&scoped=true&"
import script from "./MonthlyPaymentCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyPaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPaymentCard.vue?vue&type=style&index=0&id=3885e5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885e5da",
  null
  
)

export default component.exports